/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/**
 * Redraws once `promise` settles, then absorbs the rethrow.
 *
 * `PaginatedListState.refresh()` and `app.store.find()` clear their loading flags *after* their own
 * last redraw, so anything rendered outside a route render — a modal, a dropdown menu — has to draw
 * itself. Both also reject on failure, and `app.request` has already alerted the user by then.
 */
export default function redrawWhenSettled(promise: Promise<unknown>): void {
	promise.finally(() => m.redraw()).catch(() => {});
}
